// Utilizar esse módulo para formatar datas com fuso horário específico
import moment from 'moment-timezone';

// Convertea data/hora para timezone do usuário considerando data/hora dada esteja no timezone do servidor
moment.out = (date, customTimezone = null) => {
  const userTimezone = localStorage.getItem('userTimezone');
  const appTimezone = localStorage.getItem('appTimezone');

  return moment.tz(date, appTimezone).tz(customTimezone ?? userTimezone);
};

// Convertea data/hora para timezone do servidor considerando data/hora dada esteja no timezone do usuário

moment.in = (date, customTimezone = null) => {
  const userTimezone = localStorage.getItem('userTimezone');
  const appTimezone = localStorage.getItem('appTimezone');
  return moment.tz(moment.out(date), customTimezone ?? userTimezone).tz(appTimezone);
};

// Convertea data/hora para timezone do servidor considerando data/hora dada esteja no timezone do usuário
moment.srv = (date, customTimezone = null) => {
  const userTimezone = localStorage.getItem('userTimezone');
  const appTimezone = localStorage.getItem('appTimezone');
  return moment.tz(date, customTimezone ?? userTimezone).tz(appTimezone);
};

export default moment;
